import Phaser from 'phaser';
import SoundControlWidget from './SoundControlWidget';
import BackboardMeter from './meters/BackboardMeter';
import TextHelpers from '../utils/misc/TextHelpers';

const INNER_GAME_WIDTH = 1000;

const fontStyles = {
    font: 'skeefontBold',
    fill: 0xFFFFFF,
    fontSize: 34
};

class TopBar extends Phaser.Group {
    constructor(game) {
        super(game);

        this.name = 'TopBar';
        this.init();
    }

    init() {
        this.background = this.game.add.image(0, 0, 'skee', 'top-bar-bg.png', this);
        this.leftLogo = this.game.add.image(342, 12, 'skee', 'top-bar-left-logo.png', this);
        this.rightLogo = this.game.add.image(604, 12, 'skee', 'top-bar-right-logo.png', this);
        this.backboardMeter = new BackboardMeter(this.game);
        this.add(this.backboardMeter);

        this.soundFxToggler = new SoundControlWidget(this.game, 'soundFxLabel.png', 'fxVolume');
        this.musicToggler = new SoundControlWidget(this.game, 'soundLabel.png', 'musicVolume', 0.1);

        this.soundFxToggler.x = this.musicToggler.x = 16;
        this.soundFxToggler.y = 24;
        this.soundFxToggler.scale.set(0.7);

        this.musicToggler.y = 60;
        this.musicToggler.scale.set(0.7);

        this.add(this.soundFxToggler);
        this.add(this.musicToggler);

        this.initBallsMeter();
    }

    initBallsMeter() {
        const x = this.background.width - 180;

        this.ballsMeter = TextHelpers.createBitmapTextField(x, 10, fontStyles, this.game.logic.ballsLeft, this);
        this.ballsMeter.anchor.setTo(0.5, 0);
        this.ballsLabel = this.game.add.image(x, 54, 'skee', 'ballsCounterLabel.png', this);
        this.ballsLabel.anchor.setTo(0.5, 0);
        this.ballsLabel.x = this.ballsMeter.x = x;

        this.game.logic.onSignalBallsLeftChanged.add(ballsLeft => {
            this.ballsMeter.text = ballsLeft;
        });
    }

    frameUpdate(dt) {
        this.backboardMeter.frameUpdate(dt);
        this.soundFxToggler.refresh();
        this.musicToggler.refresh();
    }

    updateElementPositions(parentOffset) {
        const left = parentOffset > 0 ? 0 : -parentOffset;
        const right = INNER_GAME_WIDTH - left;
        const width = right - left;

        this.soundFxToggler.x = this.musicToggler.x = left + 16;

        this.leftLogo.visible = this.rightLogo.visible = width > 580;

        if (width > 420) {
            this.ballsLabel.x = this.ballsMeter.x = right - 130 * (width / 1300);
            this.ballsLabel.scale.setTo(1);
            this.toggleSoundTogglersLabel(true);
        } else {
            this.ballsLabel.x = this.ballsMeter.x = right - 14;
            this.ballsLabel.scale.setTo(0.65);
            this.toggleSoundTogglersLabel(false);
        }
    }

    toggleSoundTogglersLabel(hasLabel) {
        const scale = hasLabel ? 0.7 : 1;

        this.soundFxToggler.toggleLabel(hasLabel);
        this.musicToggler.toggleLabel(hasLabel);
        this.soundFxToggler.scale.setTo(scale);
        this.musicToggler.scale.setTo(scale);
    }
}

export default TopBar;



// WEBPACK FOOTER //
// ./app/src/display/TopBar.js